import type { NotificationType } from '@/shared/types/enums';

export type NotificationFilterType = 'all' | 'campaign' | 'system';

/**
 * Types the preferences endpoint accepts, in display order. Kept as literals
 * rather than `NotificationType` because the backend's preference keys are a
 * different (coarser) set than the types it emits on notifications.
 */
export const NOTIFICATION_PREFERENCE_TYPES: {
  type: string;
  label: string;
  description: string;
}[] = [
  {
    type: 'CAMPAIGN_STATUS',
    label: 'Campaign status changes',
    description: 'Approvals, rejections, launches, and completions',
  },
  {
    type: 'BUDGET_ALERT',
    label: 'Budget alerts',
    description: 'Spend reaching 80% or 100% of a campaign budget',
  },
  {
    type: 'PERFORMANCE_ALERT',
    label: 'Performance alerts',
    description: 'Unusual ROAS, click-through, or delivery changes',
  },
  {
    type: 'PLATFORM_ERROR',
    label: 'Platform errors',
    description: 'Failures reported by Meta, Google, or X',
  },
  {
    type: 'ACCOUNT_UPDATE',
    label: 'Ad account updates',
    description: 'Connections, disconnections, and expiring tokens',
  },
  {
    type: 'BILLING_ALERT',
    label: 'Billing alerts',
    description: 'Payment issues and invoice notices',
  },
  {
    type: 'SYSTEM',
    label: 'System announcements',
    description: 'Product updates and maintenance notices',
  },
];

export const NOTIFICATION_TYPE_GROUPS: Record<NotificationFilterType, NotificationType[]> = {
  all: [],
  campaign: [
    'CAMPAIGN_APPROVED' as NotificationType,
    'CAMPAIGN_REJECTED' as NotificationType,
    'CAMPAIGN_COMPLETED' as NotificationType,
    'PERFORMANCE_ALERT' as NotificationType,
  ],
  system: [
    'ACCOUNT_CONNECTED' as NotificationType,
    'ACCOUNT_DISCONNECTED' as NotificationType,
    'SYSTEM' as NotificationType,
  ],
};
